import { z } from 'zod'

export const whatsappBusinessAccount = z.object({
    id: z.string(),
    companyId: z.string().nullable().optional(),
    whatsappId: z.string(),
    name: z.string(),
    createdAt: z.coerce.date().nullable().optional(),
    updatedAt: z.coerce.date().nullable().optional(),
})

export type WhatsappBusinessAccount = z.infer<typeof whatsappBusinessAccount>
